import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { OKENDO_STORE_URL } from '~/lib/constants';
import { defineElement } from '~/utils';
import { ReviewsList } from './reviews-list';

gsap.registerPlugin(ScrollToPlugin);

const PRODUCT_REVIEWS_LIST_API = `/products/shopify-[product_id]/reviews`;
const PRODUCT_REVIEWS_LIST_PARAMS = {
  limit: 5,
};

const attributes = {
  productId: 'data-product-id',
  reviewsListContainer: 'data-reviews-list',
  loadMoreButton: 'data-load-more',
  animationEnabled: 'data-animation-enabled',
};

export class ProductReviewsList extends ReviewsList {
  constructor() {
    super();
    this.productId = encodeURIComponent(this.getAttribute(attributes.productId));
    this.$reviewsListContainer = this.querySelector(`[${attributes.reviewsListContainer}]`);
    this.$loadMoreButton = this.querySelector(`[${attributes.loadMoreButton}]`);
    this.animationEnabled = this.getAttribute(attributes.animationEnabled) === 'true';
  }

  async connectedCallback() {
    this.attachEventListeners();

    const data = await this.fetchReviews(this.generateUrl(this.productId));
    if (data?.reviews) this.renderReviews(data.reviews);

    window.addEventListener('url:changed', async (event) => {
      const productId = event.detail.productId;
      const data = await this.fetchReviews(this.generateUrl(productId));

      this.renderReviews(data?.reviews || [], true);
    });
  }

  scrollToFirstReview($firstReview) {
    return;
    
    const headerHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    const announcementHeight = document.documentElement.style
      .getPropertyValue('--announcement-height')
      .replace('px', '');
    const littleAdditionalSpace = 20;
    const offset = parseInt(headerHeight) + parseInt(announcementHeight) + littleAdditionalSpace;

    $firstReview.setAttribute('tabindex', '-1');
    setTimeout(() => $firstReview.focus(), 100);

    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: $firstReview.offsetTop - offset,
        autoKill: false,
      },
    });
  }

  generateUrl(productId) {
    const urlParams = new URLSearchParams(PRODUCT_REVIEWS_LIST_PARAMS).toString();
    return `${OKENDO_STORE_URL + PRODUCT_REVIEWS_LIST_API.replace('[product_id]', productId)}?${urlParams}`;
  }
}

defineElement('product-reviews-list', ProductReviewsList);
